import * as React from 'react';
import * as MobileDetect from 'mobile-detect';
import { AuthState } from '../auth/auth.types';
import AttendanceTableComponent from './attendance.table.component';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import { red700, green700 } from 'material-ui/styles/colors';
import DataTables from 'material-ui-datatables';
import ActionCameraEnhance from 'material-ui/svg-icons/action/camera-enhance';
import { white, yellow500 } from 'material-ui/styles/colors';
import * as moment from 'moment';
import {
  AttendanceState,
  Attendance,
  CheckinState,
  FilterOption,
  AttendanceDetail,
  AttendanceDetails
} from './attendance.types';
import {
  Member,
  MembersDetailsMode,
  MembersState,
  MembersResponseData
} from '../members/members.types';
import {
  DefaultMemberPictureURL,
  DISPLAY,
  initialMemberDetail,
  TIME_BASED,
  CLASS_BASED,
  PACKAGE_BASED
} from '../members/members.constants';
import AttendanceMemberDetailsComponent from './AttendanceMemberDetailsComponent';
import MembersTableComponent from '../members/members.table.component';
import { isAdminAccount, isImpersonating } from '../admin/Util';
import { AdminState } from '../admin/admin.types';
import { BusinessState } from '../business/business.types';
import { Account } from '../account/Types';
import { ATTENDANCE, STAFF } from '../account/Constants';
import { cannotWrite, isAttendancesDisabled, isPackageDisabled } from '../util/permission.util';
import * as Webcam from 'react-webcam';
import RefreshIndicator from 'material-ui/RefreshIndicator';
import ImageUploadComponent from '../util/ImageUploadComponent';
import { isAuthTokenExpired } from '../commons/AuthTokenValidator';
import { ProgramsState, Program } from '../programs/Types';
import CircularProgress from 'material-ui/CircularProgress';
import CommonFeatures from '../commons/CommonFeatures';
import { mmsStore } from '../app/app.config';
import { UPDATE_ATTENDANCE_AFTER_CHECKIN, DEFAULT_NOT_CHECKED_IN } from './attendance.constants';
import { overlayStyle, renderOverlayLoading } from '../util/Overlay';
import { isProgramDisabled } from '../util/permission.util';
import Dialog from 'material-ui/Dialog';
import { MmsPackage, PackageState } from 'src/mms-package/Types';
import { ActionYoutubeSearchedFor } from 'material-ui/svg-icons';
import { getPackages } from 'src/mms-package/Actions';
import ReactTable from 'react-table';
import { Avatar, Toggle, AutoComplete } from 'material-ui';
import { MmsColor } from 'src/app/app.const';
import Phone from 'react-phone-number-input';
import Calendar from './CalendarComponent';

const NOT_AVAILABLE = 'N/A';
const DIVIDER = ' / ';

type Props = {
  readonly authState: AuthState
  readonly adminState: AdminState
  readonly attendanceState: AttendanceState
  readonly checkinState: CheckinState
  readonly membersState: MembersState
  readonly programsState: ProgramsState
  readonly packageState: PackageState
  readonly getAttendance: (year: number, month: number) => Promise<Response>
  readonly toAdminDashboard: () => void
  readonly toDashboard: () => void
  readonly getMembers: () => Promise<MembersResponseData>
  readonly getMember: (memberId: number) => Promise<MembersResponseData>
  readonly businessState: BusinessState
  readonly faceCheckin: (file: File, programId: number) => Promise<Response>
  readonly antiIdle: () => Promise<Response>
  readonly getPrograms: () => Promise<Response>
  readonly getPackages: () => Promise<Response>
};

type States = {
  readonly yearFieldOpen: boolean
  readonly monthFieldOpen: boolean
  readonly attendanceMember: Member
  readonly members: Array<Member>
  readonly showAttendanceModal: boolean
  readonly attendanceMode: MembersDetailsMode
  readonly attendingMemberId: string
  readonly confirmationMessage: string
  readonly foundMember: boolean
  readonly notFoundMember: boolean
  readonly screenshot: string
  readonly loading: boolean
  readonly antiIdleInterval: number
  readonly loadedAttendances: boolean
  readonly filterOption: FilterOption
  readonly filterByName: string
  readonly filterByProgram: string
  readonly checkInProgram: Program
  readonly filterByTag: string
  readonly isApiCalledAlready: boolean
  readonly loadedNewAttendances: boolean
  readonly loadingUnCheckin: boolean
  readonly selectPackageModalOpen: boolean
  readonly loadingPackageSelectOrNoShow: boolean
  readonly noShowError: string
  readonly selectedStaffs: Account[]
  readonly memberPackages: Object
  readonly filteredMemberIds: number[]
  readonly selectedMember: Member
  readonly memberSearchText: string
  readonly memberSearchData: string[]
  readonly selectedMemberMonthlyTotal: number
  readonly withProgram: boolean
};

class AttendanceHistoryComponent extends React.Component<Props, States> {

  constructor(props: Props) {
    super(props);

    this.state = {
      yearFieldOpen: false,
      monthFieldOpen: false,
      attendanceMember: initialMemberDetail,
      members: [],
      showAttendanceModal: false,
      attendanceMode: 'AUTO_ATTENDANCE',
      attendingMemberId: '',
      confirmationMessage: '',
      foundMember: false,
      notFoundMember: false,
      screenshot: '',
      loading: false,
      antiIdleInterval: 0,
      loadedAttendances: false,
      filterOption: 'Name',
      filterByName: '',
      filterByProgram: NOT_AVAILABLE,
      checkInProgram: undefined,
      filterByTag: NOT_AVAILABLE,
      isApiCalledAlready: false,
      loadedNewAttendances: true,
      loadingUnCheckin: false,
      selectPackageModalOpen: false,
      loadingPackageSelectOrNoShow: false,
      noShowError: '',
      selectedStaffs: [],
      memberPackages: new Object(),
      filteredMemberIds: [],
      selectedMember: undefined,
      memberSearchText: '',
      memberSearchData: [],
      selectedMemberMonthlyTotal: 0,
      withProgram: true
    };
  }

  componentWillReceiveProps(nextProps: Props) {
    if (this.props !== nextProps && !isAuthTokenExpired() && nextProps.authState.statusCode === 200) {

      this.setState({ loading: false });

      if (
        !this.state.loadedAttendances &&
        !isAttendancesDisabled(nextProps.authState, nextProps.adminState) &&
        !this.state.isApiCalledAlready
      ) {
        this.setState(
          { isApiCalledAlready: true },
          () => {
            var date = new Date();
            var from = new Date(date.getFullYear(), date.getMonth(), 1, 0, 0, 0, 0);
            var to = new Date(date.getFullYear(), date.getMonth() + 1, 0, 23, 59, 59, 999);

            nextProps.getAttendance(from.getTime(), to.getTime())
              .then(response => {
                switch (nextProps.attendanceState.statusCode) {
                  case 403:
                    return nextProps.toDashboard();
                  case 200:
                    return this.setState(
                      {
                        loadedAttendances: true,
                        loadedNewAttendances: true
                      }
                    );
                  default:
                    return;
                }
              });
          }
        );
      }

    }
  }

  componentWillUnmount() {
    this.setState({
      loading: false,
      loadedAttendances: false,
      selectPackageModalOpen: false,
      loadingPackageSelectOrNoShow: false,
      noShowError: '',
      selectedStaffs: undefined
    });
  }

  componentDidMount() {
    const { authState, getAttendance, toAdminDashboard, adminState, toDashboard, getPrograms } = this.props;
    if (isAdminAccount(authState) && !isImpersonating(adminState)) {
      return toAdminDashboard();
    }

    if (!isPackageDisabled(authState, adminState)) {
      this.props.getPackages();
    }

    if (
      !isAttendancesDisabled(authState, adminState) &&
      !this.state.loadedAttendances &&
      !this.state.isApiCalledAlready
    ) {
      this.setState(
        { isApiCalledAlready: true },
        () => {
          this.loadMembersList();
          getPrograms();
          var date = new Date();
          var from = new Date(date.getFullYear(), date.getMonth(), 1, 0, 0, 0, 0);
          var to = new Date(date.getFullYear(), date.getMonth() + 1, 0, 23, 59, 59, 999);
          getAttendance(from.getTime(), to.getTime())
            .then(response => {
              switch (this.props.attendanceState.statusCode) {
                case (200):
                  return this.setState(
                    {
                      loadedAttendances: true,
                      loadedNewAttendances: true
                    }
                  );
                case (403):
                  return toDashboard();
                default:
                  return;
              }
            });
        }
      );
    } else {
      toDashboard();
    }
  }

  render() {
    return (
      <CommonFeatures
        authState={this.props.authState}
        businessState={this.props.businessState}
      >
        <div className="page-header-row row mt-2">
          <div className="col-auto">
            <h3>Attendance History</h3>
          </div>
        </div>
        {this.renderAttendanceMainPage()}
      </CommonFeatures>
    );
  }

  private renderAttendanceMainPage = (): JSX.Element => {

    return (
      <div>
        <div className="center">
          <div className="cf">
            <div className="col-sm-4 fl w-30 pa2">
              <div className="row">
                <div className="col-auto">
                  <SelectField
                    autoWidth={true}
                    fullWidth={true}
                    floatingLabelText="Filter Option"
                    value={this.state.filterOption}
                    onChange={this.handleFilterOptionChange}
                    style={{ float: 'left' }}
                  >
                    <MenuItem value={'Name'} primaryText={'Name'} />
                    <MenuItem value={'Tag'} primaryText={'Tag'} />
                    <MenuItem value={'Program'} primaryText={'Program'} />
                  </SelectField>
                </div>
                <div className="col-auto">
                  {this.renderFilterInputField()}
                </div>
              </div>
              <div className="row">
                <div className="col-auto fl pl-3">
                  <RaisedButton
                    label="Clear"
                    primary={true}
                    className="float-right mr-3"
                    onClick={() => this.setState(
                      {
                        memberSearchText: '',
                        selectedMember: undefined,
                        selectedMemberMonthlyTotal: 0,
                        filterByTag: NOT_AVAILABLE
                      }, this.applyFilters
                    )
                    }
                  />
                </div>
              </div>
              <div className="text-center mt-3">
                {this.renderSpecificInfo()}
              </div>
            </div>
            <div className="col-sm-8 fl w-two-thirds pa2">
              {this.renderCalendar()}
            </div>
          </div>
        </div>
      </div>
    );
  }
  private renderFilterInputField = (): JSX.Element => {
    switch (this.state.filterOption) {
      case 'Name':
        return (
          <AutoComplete
            hintText="Name or Phone #"
            floatingLabelText="Search Member"
            searchText={this.state.memberSearchText}
            filter={AutoComplete.caseInsensitiveFilter}
            dataSource={this.state.memberSearchData}
            maxSearchResults={8}
            onUpdateInput={this.handleMemberSearchTextUpdate}
            onNewRequest={this.handleNewMemberSearchRequest}
            fullWidth={true}
          />
        );
      case 'Tag':
        return (
          <SelectField
            autoWidth={true}
            fullWidth={true}
            floatingLabelText="Filter By Tag"
            value={this.state.filterByTag}
            onChange={this.handleFilterByTagChange}
          >
            <MenuItem value={NOT_AVAILABLE} primaryText={NOT_AVAILABLE} />
            {
              this.props.businessState.business &&
              this.props.businessState.business.tags
                .map((t: string, key: number) => {
                  return <MenuItem key={key} value={t} primaryText={t} />;
                })
            }
          </SelectField>
        );
      case 'Program':
        return (
          <SelectField
            autoWidth={true}
            fullWidth={true}
            floatingLabelText="Filter By Program"
            value={this.state.filterByProgram}
            onChange={this.handleFilterByProgramChange}
          >
            <MenuItem value={NOT_AVAILABLE} primaryText={NOT_AVAILABLE} />
            {
              this.props.programsState.programs &&
              this.props.programsState.programs
                .map((p: Program, key: number) => {
                  return <MenuItem key={key} value={p.name} primaryText={p.name} />;
                })
            }
          </SelectField>
        );
      default:
        return (null);
    }
  }

  private renderCalendar = (): JSX.Element => {
    return (
      <div>
        <Toggle
          label="With Program"
          onToggle={this.handleWithProgramToggle}
          defaultToggled={true}
          labelStyle={
            {
              fontFamily: 'Roboto'
            }
          }
          style={
            {
              width: '200px'
            }
          }
        />
        <Calendar
          selectedMember={this.state.selectedMember}
          authState={this.props.authState}
          adminState={this.props.adminState}
          attendanceState={this.props.attendanceState}
          programState={this.props.programsState}
          packageState={this.props.packageState}
          getAttendance={this.props.getAttendance}
          applyFilter={this.applyFilters}
          getMonthlyTotalForSelectedMember={this.getMonthlyTotalForSelectedMember}
          withProgram={this.state.withProgram}
        />
      </div>
    );
  }

  private renderSpecificInfo = (): JSX.Element => {
    const { selectedMember } = this.state;
    return (
      <div>
        {
          (selectedMember !== undefined) ?
            <div>
              <Avatar
                size={180}
                src={selectedMember.picUrl ? selectedMember.picUrl : DefaultMemberPictureURL[0]}
                className="mr-2 center"
              />
              <div className="col-12 text-center">
                <div
                  style={{ fontSize: '23pt' }}
                >
                  <strong>
                    {selectedMember.firstName} {selectedMember.lastName}
                    {
                      (selectedMember.initial) ? ' (' + selectedMember.initial + ')' : null
                    }
                  </strong>
                </div>
              </div>
              <div className="col-12 text-center">
                <Phone
                  className="profilePhoneNumber"
                  countries={['CA']}
                  value={selectedMember.mobile1}
                  convertToNational={true}
                  inputStyle={{
                    backgroundColor: 'inherit',
                    borderBottom: '0px',
                    height: '40px',
                    fontSize: '18pt',
                    color: MmsColor.MmsBlue,
                    width: (selectedMember.mobile1) ? selectedMember.mobile1.length + 'ch' : '0ch'
                  }}
                  disabled={true}
                  onChange={Function()}
                />
              </div>
              <div className="col-12 text-center">
                <div
                  style={{ fontSize: '23pt' }}
                >
                  <strong>
                    Total Attendance :  {this.state.selectedMemberMonthlyTotal}
                  </strong>
                </div>
              </div>
            </div> : null
        }
      </div>
    );
  }

  private handleMemberSearchTextUpdate = (value: string): void => {
    if (value === '') {
      this.setState({
        memberSearchText: value,
        selectedMember: undefined
      });
    } else {
      this.setState({ memberSearchText: value });
    }
  }
  private handleNewMemberSearchRequest = (chosenRequest: string): void => {
    this.setState({ selectedMember: this.findMemberWith(chosenRequest) }, this.applyFilters);
    this.getMonthlyTotalForSelectedMember(this.applyFilters());
  }
  private findMemberWith = (value: string): Member => {
    return this.props.membersState.members.find((m: Member) =>
      (m.firstName + ' ' + m.lastName) === value.split(DIVIDER)[0] &&
      m.mobile1 === value.split(DIVIDER)[1] && m.mobile2 === value.split(DIVIDER)[2]
    );
  }

  private getMonthlyTotalForSelectedMember = (attendances: Attendance[]): void => {
    var monthlyTotal = 0;

    attendances.forEach(function (attendance) {
      for (var i = 1; i < 32; i++) {
        if (attendance.attendanceDetails[i]) {
          monthlyTotal += attendance.attendanceDetails[i].length;
        }
      }
    });
    this.setState({ selectedMemberMonthlyTotal: monthlyTotal });
  }

  private handleWithProgramToggle = (event: object, checked: boolean) => {
    this.setState({ withProgram: checked });
  }

  private handleFilterByTagChange = (event: React.SyntheticEvent<{}>, index: number, value: string): void =>
    this.setState({ filterByTag: value }, this.applyFilters)

  private handleFilterByProgramChange = (event: React.SyntheticEvent<{}>, index: number, value: string): void =>
    this.setState({ filterByProgram: value }, this.applyFilters)

  private handleFilterOptionChange = (event: React.SyntheticEvent<{}>, index: number, value: FilterOption): void =>
    this.setState(
      {
        filterOption: value,
        filterByName: '',
        filterByProgram: NOT_AVAILABLE,
        filterByTag: NOT_AVAILABLE
      },
      this.applyFilters
    )

  private applyFilters = (): Attendance[] => {
    const { attendanceState } = this.props;
    const { filterByTag, selectedMember, filterByProgram } = this.state;

    let filtered: Attendance[] = attendanceState.attendance && attendanceState.attendance.attendances;

    if (selectedMember) {
      filtered = filtered.filter((a: Attendance) =>
        a.name === selectedMember.firstName + ' ' + selectedMember.lastName);
    }

    if (filterByTag !== NOT_AVAILABLE) {
      filtered = filtered.filter((a: Attendance) => a.tags.includes(filterByTag));
    }

    if (filterByProgram !== NOT_AVAILABLE) {
      filtered = filtered.filter((a: Attendance) => a.programNames.includes(filterByProgram));
    }
    return filtered;
  }

  private loadMembersList() {
    const { getMembers } = this.props;

    getMembers()
      .then((membersResponseData) => {
        const { membersState } = this.props;
        switch (membersState.statusCode) {
          case 404:
            return;
          case 200:
            this.setState({
              members: membersState.members,
              memberSearchData: this.mapMemberToSearchData()
            });
            return;
          default:
            return;
        }
      });
  }
  private mapMemberToSearchData = (): string[] => {
    return this.props.membersState.members.map((m: Member) => m.firstName + ' ' + m.lastName +
      DIVIDER + m.mobile1 + DIVIDER + m.mobile2 + DIVIDER + m.memberId);
  }
}

export default AttendanceHistoryComponent;



// WEBPACK FOOTER //
// ./src/attendance/AttendanceHistoryComponent.tsx